import { colors, colorsMapped, spacing, sizing, borderRadii, shadows } from './shibui';
import Color from 'color'
import { SSL_OP_ALL } from 'constants';

export default {
  heading4: {
    fontSize: '1.6rem',
    fontWeight: '400',
    marginTop: spacing.md,
    marginBottom: spacing.md,
  },
  heading5: {
    fontSize: '1.28rem',
    fontWeight: '400',
    textTransform: 'uppercase',
    color: colors.graphite.color,
  },
  btn: {
    display: 'inline-block',
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 700,
    borderRadius: borderRadii.button,
    cursor: 'pointer',
    padding: '10px 36px 9px',
    letterSpacing: 1.3,
    fontSize: '1rem',
    lineHeight: '19px',
    textDecoration: 'none'
  },
  cta: {
    color: colors.ivory.color,
    padding: `${spacing.md + spacing.xs}px ${spacing.xl}px ${spacing.md + spacing.xs - 1}px`,
    marginTop: spacing.sm,
    marginBottom: spacing.sm,
    backgroundImage: `linear-gradient(-136deg, ${colors.tiger50.color} 0%, ${colors.fuss50.color} 98%)`,
    transition: 'all 260ms cubic-bezier(0.45, 0.38, 0.43, 0.98)',
    ':hover': {
      backgroundImage: `linear-gradient(-136deg, ${colors.tiger50.color} 2%, ${colors.fuss50.color} 70%)`
    },
  },
  ctaSmall: {
    padding: `${spacing.md + spacing.xs}px ${spacing.xl + spacing.xs}px ${spacing.md + spacing.xs - 1}px`,
  },
  ctaAlt: { // this is a special case CTA for use on gradient backgrounds; e.g. pricing card
    backgroundImage: 'none',
    backgroundColor: colors.ivory.color,
    ':hover': {
      backgroundImage: 'none',
      backgroundColor: colors.ivory.color,
    },
  },
  ctaSecondary: {
    marginTop: spacing.xl,
    backgroundImage: 'none',
    backgroundColor: colors.ivory.color,
    border: 'solid 2px ' + colors.seattleMuted.color,
    ':hover': {
      backgroundImage: 'none',
      backgroundColor: colors.ivory.color,
    },
  },
  ctaSecondaryText: {
    background: `linear-gradient(-136deg, ${colors.tiger50.color} 2%, ${colors.fuss50.color} 70%)`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  btnLink: {
    background: 'none',
    cursor: 'pointer',
    fontWeight: 700,
    border: 'none',
    color: colors.tiger50.color
  },
  linkNaked: {
    ':hover': {
      textDecoration: 'underline'
    },
  },
  choir: {
    backgroundColor: colorsMapped.secondary.color,
    fontFamily: "'Poppins', sans-serif",
    fontSize: 32
  },
  badge: {
    padding: `${spacing.xs}px ${spacing.sm}px`,
    backgroundColor: colors.amethyst50.color,
    color: colors.ivory.color,
    borderRadius: borderRadii.button,
    fontStyle: 'italic',
    fontSize: 13,
    fontWeight: 'bold',
    letterSpacing: 1.5,
    display: 'inline-block',
  },
  container: {
    margin: '0 auto',
    maxWidth: sizing.xxxl,
    narrow: {
      maxWidth: sizing.xxl,
      '@media screen and (max-width: 870px)': {
        width: '100%'
      },
    }
  },
  card: {
    position: 'relative',
    borderRadius: borderRadii.card,
    minWidth: sizing.md,
    boxShadow: shadows.card.boxShadow,
    transition: 'all 220ms ease',
    cursor: 'pointer',
    padding: `${spacing.lg}px ${spacing.lg}px`,
    ':hover': {
      transform: 'translateY(-3px)',
      boxShadow: shadows.cardHovered.boxShadow,
    }
  },
  cardDark: {
    backgroundColor: colors.graphite.color,
    boxShadow: shadows.cardOnDark.boxShadow,
    // boxShadow: '0 30px 3px 0 rgba(0,0,0,.4)',
    ':hover': {
      boxShadow: shadows.cardHoveredOnDark.boxShadow,
    }
  },
  leftText: {
    textAlign: 'left'
  },
  note: {
    color: Color(colors.graphite.color).fade(.3),
    fontSize: '.9rem',
    fontStyle: 'italic'
  },
  centerer: {
    textAlign: 'center',
    margin: '0 auto'
  },
  subtitle: {
    color: colors.graphite.color,
    fontSize: 15,
    marginTop: 5,
    fontWeight: 300,
    lineHeight: '22px',
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rightArrow: {
    verticalAlign: 'middle',
    paddingLeft: 5,
    overflow: 'visible',
  },
  flexDivision: {
    flexGrow: 1,
    flexBasis: 0,
    margin: spacing.md
  }
}


// WEBPACK FOOTER //
// ./src/components/assets/shared-styles.js